import styled from 'styled-components'
import { media } from 'styled-bootstrap-grid'

export const Relative = styled.div`
  position: relative;
`

export const BodyText = styled.div`
  color: ${props => props.theme.colors.text};
  font-size: 22px;
  font-weight: 300;
  line-height: 30px;

  ${media.xs`
    font-size: 16px;
    line-height: 22px;
  `}

  h1, h2, h3, h4, h5 {
    color: ${props => props.theme.colors.tones.dark};
    line-height: normal;
  }

  h1 {
    font-size: 2.827em;
    font-weight: 300;
  }

  h2 {
    font-size: 1.999em;
    font-weight: 350;
  }

  h3 {
    font-size: 1.414em;
    font-weight: 350;
  }

  h4 {
    font-size: 1em;
    font-weight: 400;
  }

  p {
   margin-bottom: 20px;
  }

  ul, ol {
    list-style-position: outside;
    margin: 0 0 0px 0;
    padding-left: 20px;

    li {
      margin-bottom: 15px;
      padding-left: 20px;

      p {
        color: ${props => props.theme.colors.text};
        font-size: 20px;
        margin-bottom: 0;
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/ui/styles/utils.js